import {
  atLeastOneDigitRegExp,
  atLeastOneLowerCaseLetterRegExp,
  atLeastOneSpecialCharacterRegExp,
  atLeastOneUpperCaseLetterRegExp,
  mailRegExp,
  onlyNumberRegExp,
  passwordRegExp
} from './regExp';
import { Validator } from './types';
import validateField from './validateField';
/**
 * Validation functions
 */

/**
 * Email validator
 * @param email string
 */
const isValidEmail: Validator = (email) => {
  if (!mailRegExp.test(email)) {
    return { status: 'error', message: 'Indirizzo e-mail non valido' };
  }
  return undefined;
};

/**
 * Password validators
 * @param password string
 */
const passwordLenghtCheck: Validator = (password) => {
  if (password.length < 8) {
    return { status: 'error', message: 'La password deve essere lunga almeno 8 caratteri' };
  }
  return undefined;
};

const passwordDigitCheck: Validator = (password) => {
  if (!atLeastOneDigitRegExp.test(password)) {
    return { status: 'error', message: 'La password deve contenere almeno un numero' };
  }
  return undefined;
};

const passwordLowerCaseCheck: Validator = (password) => {
  if (!atLeastOneLowerCaseLetterRegExp.test(password)) {
    return { status: 'error', message: 'La password deve contenere almeno una lettera minuscola' };
  }
  return undefined;
};

const passwordUpperCaseCheck: Validator = (password) => {
  if (!atLeastOneUpperCaseLetterRegExp.test(password)) {
    return { status: 'error', message: 'La password deve contenere almeno una lettera maiuscola' };
  }
  return undefined;
};

const passwordSpecialCharacterCheck: Validator = (password) => {
  if (!atLeastOneSpecialCharacterRegExp.test(password)) {
    return {
      status: 'error',
      message: 'La password deve contenere almeno uno dei seguenti caratteri speciali: !$%&/=?^*+-;,.#*'
    };
  }
  return undefined;
};

const isValidPassword: Validator = (password) => {
  if (!passwordRegExp.test(password)) {
    return { status: 'error', message: 'La password inserita non è valida' };
  }
  return undefined;
};

const isANumber: Validator = (value) => {
  if (!onlyNumberRegExp.test(value)) {
    return { status: 'error', message: 'Non è un numero' };
  }
  return undefined;
};

export const passwordValidators = {
  passwordLenghtCheck,
  passwordDigitCheck,
  passwordLowerCaseCheck,
  passwordUpperCaseCheck,
  passwordSpecialCharacterCheck
};

export const validators = { validateField, isValidEmail, isValidPassword, isANumber };
